import axios from 'axios';

/**
 * 인스턴스 생성 및 초기화
 */
function createJsonInstance() {
  return axios.create({
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

function createFormInstance() {
  return axios.create({
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export const instance = createJsonInstance();
export const instance2 = createFormInstance();
